if (!customElements.get('gift-cart-note')) {
  customElements.define(
    'gift-cart-note',
    class GiftCartNote extends HTMLElement {
      constructor() {
        super();
        this.note = this.querySelector('.gift-cart-note__textarea');
        this.count = this.querySelector('.gift-cart-note__count');

        if (this.note) {
          this.setupEmojiRemoval();
          this.note.addEventListener('input', this.giftCartNoteInputHandler.bind(this));
          this.note.addEventListener('input', this.updateNoteCount.bind(this));
          this.updateNoteCount();
        }
      }

      loadNoteFromLocalStorage() {
        try {
          if ('localStorage' in window) {
            const storedNote = localStorage.getItem('cart_note');
            if (storedNote) {
              this.note.value = storedNote;
              this.updateNoteCount();
              this.updateCartAttributes({ _giftPackageNote: storedNote });
            }
          }
        } catch (error) {
          // localStorage not available or error reading
        }
      }

      giftCartNoteInputHandler(event) {
        const originalValue = event.target.value;
        const cleanedValue = this.removeEmojis(originalValue);
        
        if (originalValue !== cleanedValue) {
          event.target.value = cleanedValue;
        }

        const cart_note = cleanedValue;
        if (cart_note.length <= 100) {
          try {
            if ('localStorage' in window) {
              localStorage.setItem('cart_note', cart_note);
            }
          } catch (error) {
            // localStorage not available
          }

          const debouncedUpdate = debounce(() => {
            this.updateCartAttributes({ _giftPackageNote: cart_note });
          }, ON_CHANGE_DEBOUNCE_TIMER);

          debouncedUpdate();
        } else {
          event.target.value = cart_note.substring(0, 100);
          this.updateNoteCount();
        }
      }

      removeEmojis(text) {
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
        return text.replace(emojiRegex, '');
      }

      setupEmojiRemoval() {
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

        this.note.addEventListener('paste', (event) => {
          event.preventDefault();
          const pastedText = (event.clipboardData || window.clipboardData).getData('text');
          const cleanedText = this.removeEmojis(pastedText);
          const currentValue = this.note.value;
          const start = this.note.selectionStart;
          const end = this.note.selectionEnd;
          const newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);
          
          if (newValue.length <= 100) {
            this.note.value = newValue;
            this.note.setSelectionRange(start + cleanedText.length, start + cleanedText.length);
            this.updateNoteCount();
            
            try {
              if ('localStorage' in window) {
                localStorage.setItem('cart_note', newValue);
              }
            } catch (error) {
              // localStorage not available
            }

            const debouncedUpdate = debounce(() => {
              this.updateCartAttributes({ _giftPackageNote: newValue });
            }, ON_CHANGE_DEBOUNCE_TIMER);

            debouncedUpdate();
          } else {
            const truncatedValue = newValue.substring(0, 100);
            this.note.value = truncatedValue;
            this.note.setSelectionRange(100, 100);
            this.updateNoteCount();
            
            try {
              if ('localStorage' in window) {
                localStorage.setItem('cart_note', truncatedValue);
              }
            } catch (error) {
              // localStorage not available
            }

            const debouncedUpdate = debounce(() => {
              this.updateCartAttributes({ _giftPackageNote: truncatedValue });
            }, ON_CHANGE_DEBOUNCE_TIMER);

            debouncedUpdate();
          }
        });
      }

      updateNoteCount() {
        const remainingChars = 100 - this.note.value.length;
        if (this.count) {
          this.count.textContent = `You have ${remainingChars} characters remaining`;
        }
      }

      async updateCartAttributes(attributes) {
        const body = JSON.stringify({ attributes: attributes });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        console.log('updateCartAttributes', attributes);
      }
    }
  );
}
